﻿/**
* DevExpress Analytics (query-builder\wizard\stateManager.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _utils_1 = require("../../serializer/_utils");
var StateManager = (function () {
    function StateManager(globalState, pageFactory) {
        this.globalState = globalState;
        this.pageFactory = pageFactory;
        this.defaultState = _utils_1.extend(true, {}, globalState);
    }
    StateManager.prototype._getPageState = function (pageId, state) {
        if (state === void 0) { state = this.globalState; }
        return this.pageFactory.getMetadata(pageId).getState(state);
    };
    StateManager.prototype.setPageState = function (pageId, data) {
        this.pageFactory.getMetadata(pageId).setState(data, this.getPageState(pageId));
    };
    StateManager.prototype.getPageState = function (pageId) {
        return this._getPageState(pageId);
    };
    StateManager.prototype.resetPageState = function (pageId) {
        var defaultState = _utils_1.extend(true, {}, this._getPageState(pageId, this.defaultState));
        this.pageFactory.getMetadata(pageId).resetState(this.getPageState(pageId), defaultState);
    };
    StateManager.prototype.getCurrentState = function () {
        return this.globalState;
    };
    StateManager.prototype.reset = function () {
        this.globalState.reset();
    };
    return StateManager;
}());
exports.StateManager = StateManager;
